export default "__VITE_ASSET__WRWW6gcX__"